import {MusicResultTableSong} from "@/components/MusicResultTableSong";
import {PlaylistGrid} from "@/components/PlaylistGrid";
import Grid from "@mui/material/Grid";

export const MusicResultTable = ({songs, viewType, onPlaySong, ...props}) => {
    
    const handlePlaySong = (song) => {
        if (onPlaySong) {
            onPlaySong(song);
        }
    }


    if (viewType === 'list') {
        return (
            songs?.map((song) => (
                <Grid item key={song.id} xs={12}>
                  <MusicResultTableSong song={song} onPlaySong={handlePlaySong} />
                </Grid>
            ))
        );
    }

    if (viewType === 'grid') {
        return (
            songs?.map((song) => (
                <Grid item key={song.id} xs={12} sm={6}>
                  <PlaylistGrid song={song} onPlaySong={handlePlaySong} />
                </Grid>
            ))
        );
    }
};
                      